const POSTS_ACTION = {
  CREATE_NEW: 'POSTS_CREATE_NEW',
  CREATE: 'POSTS_CREATE',
  DELETE: 'POSTS_DELETE',
  LOAD: 'POSTS_LOAD',
  LOAD_ARTICLES: 'POSTS_LOAD_ARTICLES',
  SAVE: 'POSTS_SAVE',
  MARK_AS_READ: 'POSTS_MARK_AS_READ',
  MARK_AS_VIEWED: 'POSTS_MARK_AS_VIEWED',
  SAVE_AFTER_ASSOCIATION_SAVED: 'POSTS_SAVE_AFTER_ASSOCIATION_SAVED',
  UPDATE_CURRENT: 'POSTS_UPDATE_CURRENT',
  UPDATE_TITLE: 'POSTS_UPDATE_TITLE',
  UPDATE_TYPE: 'POSTS_UPDATE_TYPE',
  UPDATE_DESCRIPTION: 'POSTS_UPDATE_DESCRIPTION',
  UPDATE_URL: 'POSTS_UPDATE_URL',
  UPDATE_IMAGE: 'POSTS_UPDATE_MEDIA',
  UPDATE_PUBLISHED_AT: 'POSTS_UPDATE_PUBLISHED_AT',
  RESET_PUBLISHED_AT: 'POSTS_RESET_PUBLISHED_AT'
}

export default POSTS_ACTION
